<template>
    <el-card>
        <div class="transaction-list-card">
            <el-table
                v-loading="loading"
                :data="operations"
                :empty-text="translate('messages.view.no_data')"
                highlight-current-row
            >
                <el-table-column
                    min-width="120px"
                    prop="operacao"
                    :label="translate('table.operation')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{
                                scope.row.operacao ||
                                (scope.row.codigoTipoTransacao
                                    ? translate(
                                          'messages.operations.' +
                                              scope.row.codigoTipoTransacao.toLowerCase()
                                      )
                                    : '-')
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="135px"
                    prop="numeroDocumentoTraslado"
                    :label="translate('table.transport_doc_number')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{ scope.row.numeroDocumentoTraslado || '-' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    width="138px"
                    prop="realizadaEm"
                    :label="translate('table.operation_date')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div>
                            {{
                                formatDateTime(
                                    scope.row.realizadaEm ||
                                        scope.row.dataTransacao
                                )[0]
                            }}
                        </div>
                        <div class="table_second-row-label">
                            <i class="mdi mdi-clock-outline"></i>
                            {{
                                formatDateTime(
                                    scope.row.realizadaEm ||
                                        scope.row.dataTransacao
                                )[1]
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="150px"
                    prop="origem"
                    :label="translate('table.origin')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{
                                formatText(
                                    scope.row.origem ||
                                        scope.row.armazemOrigem ||
                                        scope.row.nomeOrigem
                                )
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="150px"
                    prop="destino"
                    :label="translate('table.destination')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{
                                formatText(
                                    scope.row.destino ||
                                        scope.row.armazemDestino ||
                                        scope.row.nomeDestino
                                )
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="150px"
                    prop="produto"
                    :label="translate('table.product')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <div class="transaction-list_text">
                            {{
                                formatText(
                                    scope.row.produto || scope.row.nomeProduto
                                )
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    width="135px"
                    prop="volumeEntrada"
                    :label="translate('table.volume_ton')"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        {{
                            scope.row.volumeTonFormatado ||
                            formatNumber(
                                scope.row.volumeEntrada ||
                                    scope.row.volumeTon ||
                                    scope.row.volume
                            )
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    width="90px"
                    :label="translate('table.actions')"
                    align="center"
                    label-class-name="transaction-list-table_label"
                >
                    <template v-slot:default="scope">
                        <el-dropdown class="action-button" trigger="click">
                            <span class="el-dropdown-link">
                                <i class="mdi mdi-dots-vertical" />
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    icon="el-icon-map-location"
                                    @click.native="
                                        openViewTerritoriesModal(scope.row)
                                    "
                                >
                                    {{
                                        translate(
                                            'messages.view.view_territories'
                                        )
                                    }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <div class="transaction-list-pagination">
                <div class="total">
                    <span
                    >{{ totalElements}}
                        {{ translate('messages.view.results') }}</span
                    >
                    <div style="margin: 0 20px"></div>
                    <span>{{ translate('messages.view.views_by_page') }}:</span>
                    <el-pagination
                        @size-change="handleSizeChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="sizes"
                        :total="totalElements"
                    />
                </div>
                <div class="prev_next">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="prev, pager, next, jumper"
                        :total="totalElements"
                    />
                </div>
            </div>
            <view-territories-modal
                v-if="showViewTerritoriesModal"
                :show="showViewTerritoriesModal"
                :transaction="selectedTransaction"
                @close="showViewTerritoriesModal = false"
            />
        </div>
    </el-card>
</template>

<script>
import IndustriaModuleService from '@/services/IndustriaModuleService';
import ViewTerritoriesModal from '@/modules/warehouse/views/components/ViewTerritoriesModal.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'FactoryTransactionList',
    components: {
        ViewTerritoriesModal
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            page: 1,
            size: 10,
            totalElements: 0,
            operations: [],
            selectedTransaction: null,
            showViewTerritoriesModal: false,
            loading: false
        };
    },
    mounted() {
        if (this.filters?.idArmazem) {
            this.getOperations();
        }
    },
    watch: {
        filters: {
            handler() {
                this.page = 1;
                this.getOperations();
            },
            deep: true
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        handleSizeChange(size) {
            this.page = 1;
            this.size = size;
            this.getOperations();
        },
        handleCurrentChange(page) {
            this.page = page;
            this.getOperations();
        },
        async getOperations() {
            if (!this.filters?.idArmazem) return;

            this.loading = true;
            try {
                const { idArmazem, ...otherFilters } = this.filters;
                const { data } =
                    await IndustriaModuleService.getFactoryOperations(
                        idArmazem,
                        this.page - 1,
                        this.size,
                        otherFilters
                    );

                this.operations = data.content;
                this.totalElements = data.totalElements;
            } catch (e) {
                this.$notify.error({
                    message: this.translate(
                        'messages.error_fetching_operations'
                    )
                });
            } finally {
                this.loading = false;
            }
        },
        formatDateTime(dateTimeFromApi) {
            return formatters.splitApiDateTimeForTable(dateTimeFromApi, this.$i18n.locale);
        },
        formatText(text) {
            if (!text) return '-';

            const normalizedText = text.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const products = ['CASCA', 'OLEO', 'FARINHA', 'SOJA', 'MILHO'];

            if (products.includes(normalizedText)) {
                return this.translate('table.product_codes.' + normalizedText.toLowerCase());
            }

            return text;
        },
        formatNumber(value) {
            if (value === null || value === undefined) return '-';
            return formatters.minFormatNumber(value, 2, this.$i18n.locale);
        },
        openViewTerritoriesModal(transaction) {
            this.selectedTransaction = transaction;
            this.showViewTerritoriesModal = true;
        }
    }
};
</script>

<style scoped lang="scss">
.transaction-list-card {
    margin-top: -8px;
    .el-table {
        border-radius: 5px;
        height: calc(100% - 60px) !important;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }
    .transaction-list-pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin: 20px 12px 0;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}

::v-deep .transaction-list-table_label {
    word-break: keep-all !important;
}
</style>
